module.exports = __webpack_public_path__ + "static/img/soft_4.772b368.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/soft_4.png
// module id = QMhQ
// module chunks = 0